(() => {
  'use strict';
  const data = document.getElementById('gs-canvas-visual-pilot-data');
  if (!data || window.gsCanvasVisualPilot) return;
  window.gsCanvasVisualPilot = true;
  const config = JSON.parse(data.textContent);
  if (String(config.productId) !== "9071629828437") return;
  config.finishByVariant = window.GSFinishKinds || {};
  const locale = String(config.locale || document.documentElement.lang || 'fr').toLowerCase().split('-')[0];
  const copy = ({
    fr: {finish:'Finition', size:'Dimensions en centimètres', canvas:window.GSFinishLabels.canvas, kit:window.GSFinishLabels.kit, kitOption:window.GSFinishLabels.kit, alt:' — aperçu de la toile', kitCaption:'À assembler en quelques minutes · rendu galerie', canvasCaption:'Toile livrée roulée - chassis non inclus', canvasDisclosure:'Toile livrée roulée · châssis non inclus'},
    en: {finish:'Finish', size:'Dimensions in centimetres', canvas:window.GSFinishLabels.canvas, kit:window.GSFinishLabels.kit, kitOption:window.GSFinishLabels.kit, alt:' — canvas preview', kitCaption:'Assemble in minutes · gallery look', canvasCaption:'Canvas delivered rolled - stretcher not included', canvasDisclosure:'Canvas delivered rolled · stretcher not included'},
    es: {finish:'Acabado', size:'Medidas en centímetros', canvas:window.GSFinishLabels.canvas, kit:window.GSFinishLabels.kit, kitOption:window.GSFinishLabels.kit, alt:' — vista previa del lienzo', kitCaption:'Se monta en minutos · acabado de galería', canvasCaption:'Lienzo entregado enrollado - bastidor no incluido', canvasDisclosure:'Lienzo entregado enrollado · bastidor no incluido'}
    ,de: {finish:'Ausführung',size:'Maße in Zentimetern',canvas:window.GSFinishLabels.canvas,kit:window.GSFinishLabels.kit,kitOption:window.GSFinishLabels.kit,alt:' — Leinwandvorschau',kitCaption:'In wenigen Minuten selbst zusammenbauen',canvasCaption:'Gerollte Leinwand — ohne Keilrahmen',canvasDisclosure:'Gerollte Leinwand · Keilrahmen nicht enthalten'},
    nl: {finish:'Afwerking',size:'Afmetingen in centimeters',canvas:window.GSFinishLabels.canvas,kit:window.GSFinishLabels.kit,kitOption:window.GSFinishLabels.kit,alt:' — canvasvoorbeeld',kitCaption:'Zelf in enkele minuten monteren',canvasCaption:'Canvas opgerold geleverd — zonder spanraam',canvasDisclosure:'Canvas opgerold geleverd · spanraam niet inbegrepen'}
  })[locale];
  if (!copy) return;
  const explicitFinishes = Object.prototype.hasOwnProperty.call(config, 'finishByVariant');
  const finishIndex = 'option' + (config.finishOptionIndex === 2 ? 2 : 1);
  function visualFinish(variant) {
    if (!variant) return 'unsupported';
    if (!explicitFinishes) return variant.option1 === 'toile seule' ? 'canvas' : 'kit';
    const value = config.finishByVariant?.[String(variant.id)];
    return value === 'canvas' || value === 'kit' ? value : 'unsupported';
  }
  function optionFinish(value) {
    const values = new Set(config.variants.filter(v => v[finishIndex] === value).map(visualFinish));
    return values.size === 1 ? [...values][0] : 'unsupported';
  }
  const assetBase = new URL('.', document.currentScript.src).href;
  function finishTransition(stage) {
    let target, surface;
    const apply = (finish, reset = false) => {
      if (finish === target) return;
      const initial = reset || target === undefined;
      target = finish;
      stage.dataset.finish = finish;
      surface?.setFinish(finish, initial);
    };
    const observer = new IntersectionObserver(entries => {
      if (!entries.some(e => e.isIntersecting)) return;
      observer.disconnect();
      import(assetBase + 'gs-pdp-assembly.js?v=no-wood-reveal-1').then(m => m.createSurface(stage, config, assetBase))
        .then(value => { surface = value; surface.setFinish(target, true); })
        .catch(() => { stage.dataset.renderer = 'image-fallback'; });
    }, {rootMargin:'200px'});
    observer.observe(stage);
    return apply;
  }
  // Native selects remain in their original DOM order and own commerce.
  function segmentedChoices(root) {
    root.querySelectorAll('select[data-variant-input]').forEach(select => {
      const index = select.dataset.index;
      if (index !== 'option1' && index !== 'option2') return;
      const wrapper = select.closest('.variant-wrapper');
      if (!wrapper) return;
      const isFinish = index === finishIndex;
      let group = wrapper.querySelector('.gs-cvp-choices');
      if (!group) {
        group = document.createElement('div');
        group.className = 'gs-cvp-choices ' + (isFinish ? 'gs-cvp-finishes' : 'gs-cvp-sizes');
        group.setAttribute('role', 'group');
        group.setAttribute('aria-label', isFinish ? copy.finish : copy.size);
        for (const option of select.options) {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'gs-cvp-choice';
          button.dataset.value = option.value;
          if (isFinish && optionFinish(option.value) !== 'unsupported') {
            const sheet = optionFinish(option.value) === 'canvas';
            button.innerHTML = '<svg viewBox="0 0 28 28" aria-hidden="true" focusable="false"><path d="' + (sheet ? 'M6 3h16v20H9l-4 2 1-5V3Zm3 20v-4l-3 1' : 'M5 6 19 3l5 4v17l-5 1L5 21V6Zm0 0 14 3 5-2M19 9v16') + '"/></svg>';
            button.append(document.createTextNode(sheet ? copy.canvas : copy.kit));
          } else {
            if (isFinish) button.textContent = option.textContent;
            else {
              const size = option.value.match(/^\s*(\d+)\s*[x×]\s*(\d+)\s*cm\s*$/i);
              if (size) {
                button.setAttribute('aria-label', size[1] + ' × ' + size[2] + ' cm');
                // Keep dimensions in separate tokens: the draft's broad triptych
                // text converter must not reinterpret a single canvas as a set.
                [size[1], ' × ', size[2], ' cm'].forEach(text => {
                  const token = document.createElement('span'); token.textContent = text; button.append(token);
                });
              } else button.textContent = option.value;
            }
          }
          button.addEventListener('click', () => {
            if (select.value === button.dataset.value) return;
            select.value = button.dataset.value;
            select.dispatchEvent(new Event('input', {bubbles:true}));
            select.dispatchEvent(new Event('change', {bubbles:true}));
            schedule();
          });
          group.append(button);
        }
        group.addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          const buttons = [...group.querySelectorAll('button:not(:disabled)')];
          const current = buttons.indexOf(document.activeElement);
          if (current < 0) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (current + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
          buttons[next].focus();
          buttons[next].click();
        });
        select.after(group);
        wrapper.classList.add('gs-cvp-choice-wrapper');
        wrapper.parentElement.classList.add('gs-cvp-picker');
        select.hidden = true;
      }
      for (const button of group.children) {
        const selected = button.dataset.value === select.value;
        button.setAttribute('aria-pressed', String(selected));
        const paired = root.querySelector('select[data-variant-input][data-index="' + (index === 'option1' ? 'option2' : 'option1') + '"]');
        const available = config.variants.some(v => v[index] === button.dataset.value && (!paired || v[paired.dataset.index] === paired.value) && v.available);
        button.disabled = select.disabled || !available;
      }
    });
  }
  function init() {
    const root = document.getElementById('shopify-section-' + config.sectionId);
    if (!root) return;
    const slide = root.querySelector('.product-main-slide[data-index="0"]');
    const form = root.querySelector('form.product-single__form');
    const variantInput = form?.querySelector('[name="id"]');
    const atc = form?.querySelector('[data-add-to-cart]');
    if (!slide || !variantInput || !atc) return;
    const variant = config.variants.find(v => String(v.id) === variantInput.value);
    const visual = visualFinish(variant);
    const zoom = slide.querySelector('.photoswipe__image');
    if (visual === 'unsupported') {
      const oldStage = slide.querySelector('.gs-cvp-stage');
      if (oldStage) { oldStage.style.display = 'none'; oldStage.dataset.suspended = 'true'; }
      slide.classList.remove('gs-cvp-slide');
      const oldDisclosure = form.querySelector('.gs-cvp-disclosure');
      if (oldDisclosure) oldDisclosure.hidden = true;
      if (zoom && zoom.gsCvpNativeZoom) {
        for (const [key, value] of Object.entries(zoom.gsCvpNativeZoom)) {
          if (value === undefined) delete zoom.dataset[key]; else zoom.dataset[key] = value;
        }
      }
      if (oldStage) segmentedChoices(root);
      return;
    }
    root.classList.add('gs-cvp-scope');
    let stage = slide.querySelector('.gs-cvp-stage');
    if (!stage) {
      stage = document.createElement('div');
      stage.className = 'gs-cvp-stage';
      stage.innerHTML = '<div class="gs-cvp-shadow"><div class="gs-cvp-object"><img class="gs-cvp-face" alt="Jamais mieux fleuri que par soi-même — aperçu de la toile sans cadre décoratif" width="1006" height="1280"><span class="gs-cvp-right" aria-hidden="true"></span><span class="gs-cvp-top" aria-hidden="true"></span></div></div><span class="gs-cvp-caption"></span>';
      stage.querySelector('.gs-cvp-object').style.aspectRatio = config.faceWidth + '/' + config.faceHeight;
      stage.querySelector('img').alt = (config.artTitle || document.title) + copy.alt;
      stage.querySelector('img').width = config.faceWidth;
      stage.querySelector('img').height = config.faceHeight;
      stage.style.setProperty('--wrap-right', 'url("' + config.wrapRight + '")');
      stage.style.setProperty('--wrap-top', 'url("' + config.wrapTop + '")');
      stage.querySelector('img').crossOrigin = 'anonymous';
      stage.querySelector('img').src = config.art;
      stage.setVisualFinish = finishTransition(stage);
      stage.querySelector('img').addEventListener('load', () => { if (stage.dataset.suspended !== 'true') slide.classList.add('gs-cvp-slide'); }, {once:true});
      slide.append(stage);
    }
    const resumed = stage.dataset.suspended === 'true';
    stage.style.display = '';
    stage.dataset.suspended = 'false';
    if (stage.querySelector('img').complete && stage.querySelector('img').naturalWidth) slide.classList.add('gs-cvp-slide');
    if (zoom) {
      if (!zoom.gsCvpNativeZoom) zoom.gsCvpNativeZoom = Object.fromEntries(['photoswipeSrc','photoswipeWidth','photoswipeHeight'].map(key => [key, zoom.dataset[key]]));
      zoom.dataset.photoswipeSrc = config.zoomArt || config.art;
      zoom.dataset.photoswipeWidth = String(config.faceWidth);
      zoom.dataset.photoswipeHeight = String(config.faceHeight);
    }
    let disclosure = form.querySelector('.gs-cvp-disclosure');
    if (!disclosure) {
      disclosure = document.createElement('p');
      disclosure.className = 'gs-cvp-disclosure';
      disclosure.setAttribute('aria-live','polite');
      atc.before(disclosure);
    }
    disclosure.hidden = false;
    const finish = root.querySelector('select[data-variant-input][data-index="' + finishIndex + '"]');
    if (finish) {
      const label = root.querySelector('label[for="'+finish.id+'"]');
      if (label && label.textContent.trim() !== copy.finish) label.textContent = copy.finish;
      for (const option of finish.options) {
        const mode = optionFinish(option.value);
        const text = mode === 'canvas' ? copy.canvas : mode === 'kit' ? copy.kitOption : option.textContent;
        if (option.textContent !== text) option.textContent = text;
      }
    }
    segmentedChoices(root);
    const kit = visual === 'kit';
    const key = String(variant.id);
    if (stage.dataset.variant === key && !resumed) return;
    stage.dataset.variant = key;
    stage.setVisualFinish(visual, resumed);
    stage.querySelector('.gs-cvp-caption').textContent = kit ? copy.kitCaption : copy.canvasCaption;
    disclosure.textContent = kit ? copy.kitCaption : copy.canvasDisclosure;
  }
  let queued = false;
  const schedule = () => { if (queued) return; queued = true; requestAnimationFrame(() => { queued = false; init(); }); };
  document.addEventListener('change', schedule);
  document.addEventListener('variant:change', schedule);
  window.addEventListener('popstate', schedule);
  new MutationObserver(schedule).observe(document.getElementById('shopify-section-' + config.sectionId) || document.body, {childList:true,subtree:true});
  init();
})();
